import {
  applyMiddleware,
  compose,
  createStore,
  Middleware,
  Reducer,
  DeepPartial,
  Store,
} from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import type { Action } from './types';

import { clientEnvironments } from '../config';
import { RootState } from './types/root-state';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose;
  }
}

const getMiddlewares = (customMiddlewares, isServerSideRender, useDevtools) => {
  const middlewares: Middleware[] = [thunk, ...customMiddlewares];
  if (clientEnvironments.isDev && !isServerSideRender) {
    const composeEnhancers =
      useDevtools && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        : compose;
    middlewares.push(createLogger({ collapsed: true }));
    return composeEnhancers(applyMiddleware(...middlewares));
  }
  return compose(applyMiddleware(...middlewares));
};

const createStoreManual = ({
  rootReducer,
  customMiddlewares = [],
  preloadedState,
  isServerSideRender = false,
  useDevtools = false,
}: {
  rootReducer: Reducer<RootState, Action>;
  customMiddlewares?: any[];
  preloadedState?: DeepPartial<RootState>;
  isServerSideRender?: boolean;
  useDevtools?: boolean;
}): Store<RootState> => {
  const middlewares = getMiddlewares(
    customMiddlewares,
    isServerSideRender,
    useDevtools
  );
  // @ts-ignore
  return createStore(rootReducer, preloadedState || {}, middlewares);
};

export default createStoreManual;
